import React from 'react';
import PropTypes from 'prop-types';
import {Link} from 'react-router-dom';
import utils from "../../utils/utils";
import DATE_FORMAT from "../../components/constants/dateFormat";

const AdminUserRow = ({user}) => {
  const avatar = user.avatar? <img src={user.avatar.thumbnailImage} alt={user.screenName + ' avatar'}/>: '';
  const dateCreated = utils.getDateFromString(user.dateCreated).format(DATE_FORMAT.displayWithTime);

  return (
    <tr>
      <th scope="row">
        <Link to={`/admin/users/${user.id}`}>
          {user.id}
        </Link>
      </th>
      <td className="admin-user__image">
        <Link to={`/admin/users/${user.id}`}>
          {avatar}
        </Link>
      </td>
      <td>
        <Link to={`/admin/users/${user.id}`}>
          {user.screenName}
        </Link>
      </td>
      <td>
        {user.contact}
      </td>
      <td>
        {user.phoneNumber}
      </td>
      <td>{dateCreated}</td>
      <td>{user.attributionChannel? user.attributionChannel.channel: ''}</td>
      <td>
        <Link to={`/user/edit/${user.id}`} className="link">
          Edit profile
        </Link>
      </td>
    </tr>
  );
}

AdminUserRow.propTypes = {
    user: PropTypes.object.isRequired,
};

AdminUserRow.defaultProps = {
    user: {},
};

export default AdminUserRow;